import { render, staticRenderFns } from "./CustomerStatisticsWidget.vue?vue&type=template&id=3da97cd0&scoped=true"
import script from "./CustomerStatisticsWidget.vue?vue&type=script&lang=js"
export * from "./CustomerStatisticsWidget.vue?vue&type=script&lang=js"
import style0 from "./CustomerStatisticsWidget.vue?vue&type=style&index=0&id=3da97cd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da97cd0",
  null
  
)

export default component.exports